import React, { useEffect } from "react";
import QualityBlock from "../QualityBlock/QualityBlock";
import { useDispatch, useSelector } from "react-redux";
import { removeSelectedSizes, setSelectedSizes } from "../../appState/slices/auth/authSlice";

const SizeDropDown = ({updateSelectedFilter}) => {
    const availableSizes = useSelector(state => state.product.availablesizes);
    const selectedsizes = useSelector(state => state.auth.category.selectedsizes);
    const dispatch = useDispatch();
    useEffect(() => {
        updateSelectedFilter("size");
    })
    const selectSize = (size) => {
        if(selectedsizes.includes(size)){
            dispatch(removeSelectedSizes(size));
        }
        else{
            dispatch(setSelectedSizes(size));
        }
    }
    return (
        <div>
            <div className="categoriesdropdown">
                {availableSizes.map(size => {
                    return (
                        <div onClick={() => selectSize(size)}
                            className={`size-option ${selectedsizes.includes(size) ? "productsizeselected" : ""
                                }`}
                        >
                            <QualityBlock size={size} />
                        </div>
                    )
                })}
            </div>
        </div>
    );
};

export default SizeDropDown;